import { Pipe, PipeTransform } from '@angular/core';
import { ABOSFunction } from '../model/ABOSFunction';

@Pipe({
  name: 'permission'
})
export class PermissionPipe implements PipeTransform {

  transform(value: Array<ABOSFunction>, permissions: Array<string>): Array<ABOSFunction> {
    return value.filter(v => permissions.includes(v.permission));
  }

}
